import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 74px;
  background: #18191B;
  border-radius: 4px;
  margin-bottom: 16.33px;
`;

export const MatchMainQuestions = styled.div`
  height: 32px;
  padding: 12px 12px 12px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
`;

export const CombineTitle = styled.h4`
  max-width: calc(100% - 150px);
  margin: 0;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #F5F6FA;
  overflow: hidden;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: initial;
`;

export const ChainWrapper = styled.span`
  display: flex;
  height: 18px;
  width: 121px;
  margin-left: 17px;

  svg {
    stroke: #00BEC1;
  }
`;

export const MatchedQuestions = styled.h5`
  margin: 0 0 0 6.8px;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  text-decoration-line: underline;
  color: #00BEC1;
  cursor: pointer;
`;